export default "__VITE_ASSET__HH2JHeaB__"